export enum Language {
    Sv = "Sv",
    En = "En"
}
